import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { environment } from 'src/app/environments/environment';
// import { ExcelExportReportInputs } from '../../models/excel-export-report.model';
import { ExcelExportReportInputs } from '../../models/excel-export-report.model';
import { ReportIssueInputs } from '../../models/reportIssue.model';
import { SharedPopupService } from '../../services/shared-popup.service';
@Component({
  selector: 'app-header-home',
  templateUrl: './header-home.component.html',
  styleUrls: ['./header-home.component.css']
})
export class HeaderHomeComponent {
  toggleSetting: boolean = false;
  showClearAll: boolean = false;
  @Input() exportReportInput!: ExcelExportReportInputs;
  @Input() settingIconShown: boolean = true;
  @Input() additionalCheck: any;
  @Input() reportIssueInput!: ReportIssueInputs;
  @Input() isHelpGuide: boolean = false;
  @Input() hasDocuments: boolean = false;
  isDocumentRepository: boolean = true;
  exportDownloads : boolean = true;
  guideUrl = environment.UserGuideSnapshotUrl;
  @Input() moduleName!: string;
  triggerNew: boolean = false;
  showExportsDownloadsPopup: boolean = false;
  showReportIssuePopup: boolean = false;
  notifications: any[] = [];
  showNotification: boolean = false;
    notificationCount: any;
  @Output() OnSettingsSel = new EventEmitter<string>();
  @Output() documentRepoClick = new EventEmitter<void>();
  constructor(private router: Router, private _authenticateService: AuthenticationService,private sharedPopup:SharedPopupService) { }

  ngOnInit() {
    if (this.moduleName != undefined || this.moduleName != null) {
      this.settingOptions();
    }
    
  
  }

  ngOnChanges() {
    if (this.moduleName != undefined || this.moduleName != null) {
      this.settingOptions();
    }
  }

  OnExportsDownloads() {
    this.showExportsDownloadsPopup = true;
  }

  onCloseExportDownloads() {
    this.showExportsDownloadsPopup = false;
  }

  OnReportIssue() {
    this.showReportIssuePopup = true;
  }

  onCloseReportIssue() {
    this.showReportIssuePopup = false;
  }

  settingOptions() {
    switch (this.moduleName) {
      case 'crosstab':
        this.isHelpGuide = false;
        this.isDocumentRepository = false;
        break;
      case 'snapshot':
        if (this.additionalCheck != undefined) {
          this.isHelpGuide = (this.additionalCheck?.find((x: any) => x.key == 'Help Guide'))?.length > 0;
        }
        this.isDocumentRepository = true;
        break;
      case 'customsnapshot':
        if (this.additionalCheck != undefined) {
        this.additionalCheck?.find((x: any) => x.key == 'Help Guide')?.value;
        }
        this.isDocumentRepository = true;
        break;
    }
  }

  redirectToLandingPage() {
    this.router.navigate(['/landing']);
  }
  onUserManagementClick() {
    this.router.navigate(['/user-management']);
  }
  onUserGuideClick() {
    const guideUrl = this.guideUrl;
    window.open(guideUrl, '_blank');
  }
  LogOut() {
    this._authenticateService.logout();
  }
  OnSettingClick() {
    this.toggleSetting = !this.toggleSetting;
  }
  closeSummary() {
    this.toggleSetting = false;
  }

  settingOptionSel(item : any){
    this.toggleSetting = false;
    this.OnSettingsSel.emit(item);
  }

  
  HandleDocumentClick() {
    this.documentRepoClick.emit();
    this.toggleSetting = false;
  }
toggleNotification() {
   let study = localStorage.getItem('selectedStudy') ?? '';
    let client = localStorage.getItem('selectedClient') ?? '';
    let userEmail = localStorage.getItem('useremail') ?? '';
    this.sharedPopup.getTriggeredAlertList(userEmail, client, study).subscribe((value: any) => {
     
      const parsedData = JSON.parse(value.Data);
      console.log('Received value from service:', parsedData);
      
       if (parsedData.TriggeredAlerts && parsedData.TriggeredAlerts.items && Array.isArray(parsedData.TriggeredAlerts.items)) {
        this.notifications = parsedData.TriggeredAlerts.items.map((alert: any) => ({
          header: alert.AlertName,
          alertId: alert.AlertId,
          text: alert.desc,
         
           checked: false,
           
        }));
      }
      this.notificationCount = parsedData.TriggeredAlerts.totalCount || 0;
       this.showNotification = !this.showNotification;
      this.showClearAll=true;
      this.triggerNew=true;
    });
  }
clearAll(checkedNotifications: any[]) {
  // Extract alert IDs from checked notifications
  const alertIds = checkedNotifications.map(notification => notification.alertId);
  

  
  // Remove notifications with matching alert IDs
  this.notifications = this.notifications.filter(
    notification => !alertIds.includes(notification.alertId)
  );
  

  
  // Update notification count
  this.notificationCount = this.notifications.length;
  
  this.sharedPopup.updateTriggeredAlertList(alertIds).subscribe(
    (response: any) => {
      
      if (this.notifications.length === 0) {
        this.showNotification = false;
        this.triggerNew = false;
      }
    },
    (error: any) => {
      console.error('Error clearing alerts:', error);
    }
  );
}
  onNotificationClick(notification: any, event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // don't toggle when clicking interactive elements (checkbox, link, button, label, select, textarea')
    if (target.closest('input, a, button, label, select, textarea')) {
      return;
    }
    notification.checked = !notification.checked;
  }
}
